export default "__VITE_ASSET__C6Vgp3vC__"